import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export abstract class IOfflineService  {
    abstract isOffline(): Observable<boolean>;
    abstract isOfflineObservable(): Observable<boolean>;
}